import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_mt-3"
}
const _hoisted_2 = { "format-key": "0" }
const _hoisted_3 = {
  key: 0,
  class: "_flexcol _gap-3 _mt-3"
}
const _hoisted_4 = { class: "gfu-hd gfu-hd--h6 _fw-n" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_optional_text = _resolveComponent("optional-text")

  return (_ctx.isGpsrVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.GpsrInformationParagraph,
          class: "gfu-bt--caption",
          "data-qa": "productinfo:GpsrInfo"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.GpsrNameLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"]),
        (_ctx.isInformationsVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productGpsrInformation, ({ headerText, content, isRichText, dataQa }, index) => {
                return (_openBlock(), _createBlock(_component_optional_text, {
                  key: `${index}-${headerText}`,
                  class: "gfu-bt--caption",
                  content: content,
                  "is-rich-text": isRichText,
                  "data-qa": dataQa
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(headerText), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content", "is-rich-text", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}